import strings from 'utils/strings';
export const DEVELOPMENT = 'development';
export const PRODUCTION = 'production';
export const TESTING = 'testing';
const validEnvironments = [DEVELOPMENT, TESTING, PRODUCTION];

const environmentFromEnvVars = PRODUCTION;

export const ENVIRONMENT = validEnvironments.includes(environmentFromEnvVars)
	? environmentFromEnvVars
	: PRODUCTION; //Default to production, in case config is missing

if (!validEnvironments.includes(ENVIRONMENT)) {
	console.warn('MISSING ENVIRONMENT SELECTOR');
}

export const timeSinceWCaltered = 1686585143000;
const rootUrls = {
	development: '',
	testing: '',
	production: '',
};
export const ROOT_URL = rootUrls[ENVIRONMENT];

const endpointUrls = {
	development: 'http://localhost:3000',
	testing:
		'http://literate-staging-legacy-env.eba-hxc8m23m.eu-central-1.elasticbeanstalk.com',
	production: 'https://screeningtest.literate.no',
};

export const ENDPOINT_URL = endpointUrls[ENVIRONMENT];

const childtestUrls = {
	development: 'http://localhost:3003',
	testing:
		'http://lit-staging-childtest.s3-website.eu-central-1.amazonaws.com/',
	production: 'http://barnetest.literate.no',
};

const childnomringtestUrls = {
	development: 'http://localhost:3006',
	testing:
		'http://followup.literate.no.s3-website.eu-central-1.amazonaws.com/',
	production: 'https://followup.literate.no',
};
export const CHILD_TEST_URL = childtestUrls[ENVIRONMENT];
export const CHILD_NORMING_TEST_URL = childnomringtestUrls[ENVIRONMENT];
export const USER_MESSAGE = true;
export const TEST_TYPES = {
	CHILD_SCREENING: 'child-screening',
	CHILD_EXPERIMENTAL: 'child-experimental',
	CHILD_FOLLOWUP: 'child-followup',
	CHILD_NORMING: 'child-norming',
	ADULT_SCREENING: 'adult-screening',
	ADULT_FOLLOWUP: 'adult-followup',
	YOUTH_SCREENING: 'youth-screening',
	YOUTH_FOLLOWUP: 'youth-followup',
};

export const TEST_TYPE_NAMES = {
	'child-screening': 'Screeningtest (barn)',
	'child-followup': 'Oppfølgingstest (barn)',
	'child-norming': 'Screeningtest (barn)',
	'child-experimental': '1-min test (talegjenkjenning)',
	'adult-screening': strings.screeningtest_adult,
	'adult-followup': 'Oppfølgingstest (voksen)',
	'youth-screening': 'Screeningtest (ungdom)',
	'youth-followup': 'Oppfølgingstest (ungdom)',
};

export const TEST_TYPES_NAMES_2 = {
	'child-screening': 'Screeningtest',
	'child-followup': 'Oppfølgingstest',
	'child-norming': 'Screeningtest',
	'child-experimental': '1-min test',
	'adult-screening': 'Screeningtest',
	'adult-followup': 'Oppfølgingstest',
	'youth-screening': 'Screeningtest',
	'youth-followup': 'Oppfølgingstest',
};

export const ALL = {
	id: 'all',
	label: strings.all,
};

export const SEARCHBYTESTKEY = {
	id: 'search',
	label: strings.searchByTestKey,
};

export const SIMULATE_RESULTS = {
	id: 'simulate',
	label: strings.simulateResults,
};

export const FEIDEDROPDOWN = {
	id: 'feidesearch',
	label: strings.searchFeide,
};

export const CONEXUSDROPDOEN = {
	id: 'conexussearch',
	label: strings.searchConexus,
};

export const VIEWMUNICIPALITY = {
	id: 'view',
	label: strings.viewMunicipality,
};
export const ADDMUNICIPALITY = {
	id: 'create',
	label: strings.addMunicipality,
};

export const VIEWSCHOOLS = {
	id: 'view',
	label: strings.viewSchools,
};
export const ADDSCHOOLS = {
	id: 'create',
	label: strings.addSchool,
};

export const CREATENOTIFICATION = {
	id: 'create',
	label: strings.createNotification,
};

export const VIEWNOTIFICATION = {
	id: 'view',
	label: strings.viewNotification,
};

export const STATUS = {
	id: '',
	label: strings.status,
};

export const SATUS = {
	id: 'all',
	label: strings.all,
};

export const LOGGED_IN = {
	id: 'logged_in',
	label: strings.loggedIn,
};
export const BLOCKED = {
	id: 'blocked',
	label: strings.blocked,
};

export const TEST_ACTIVITY = {
	id: 'test',
	label: 'test hendelser',
};
export const USER_ACTIVITY = {
	id: 'user',
	label: 'user hendelser',
};
export const SUPER_ACTIVITY = {
	id: 'super',
	label: 'super hendelser',
};

export const NOT_STARTED = {
	id: 'not_started',
	label: strings.notstarted,
};

export const NOT_DISTRIBUTED = {
	id: 'not_distributed',
	label: strings.notdistributed,
};

export const NOT_INVOICED = {
	id: 'not_invoiced',
	label: 'Ikke fakturert',
};
export const INVOICED = {
	id: 'invoiced',
	label: 'Fakturert',
};
export const DISTRIBUTED = {
	id: 'distributed',
	label: strings.distributed,
};

export const STARTED = {
	id: 'started',
	label: strings.started,
};

export const COMPLETED = {
	id: 'completed',
	label: strings.completed,
};

export const MALE = {
	id: 'm',
	label: strings.male,
};

export const FEMALE = {
	id: 'f',
	label: strings.female,
};
export const YOUNG_MALE = {
	id: 'm',
	label: strings.boy,
};

export const YOUNG_FEMALE = {
	id: 'f',
	label: strings.girl,
};

export const GENDER_LABELS = {
	f: strings.female,
	m: strings.male,
};

export const TEST_USER_INFO_LABELS = {
	juniorHigh: 'ungdomsskole',
	highSchool: 'videregående skole',
	bachelor: 'bachelor',
	master: 'mastergrad/hovedfag',
	phd: 'doktorgrad',
	youthProgram: 'Ungdomsprogram',
	accompanyingMeasures: 'Oppfølgingstiltak',
	workPreparatoryTraining: 'Arbeidsforberedende trening',
	norwegian: 'norsk',
	sapmi: 'samisk',
	russian: 'russisk',
	english: 'engelsk',
	arabic: 'arabisk',
	polish: 'polsk',
	kurdish: 'kurdisk',
	spanish: 'spansk',
	tamil: 'tamil',
	thai: 'thai',
	turkish: 'tyrkisk',
	other: 'annet',
	yes: 'ja',
	no: 'nei',
	doesNotKnow: 'vet ikke',
};

export const BANK_ID = 'BankID';
export const BANK_ID_MOBILE = 'BankIDMobile';
export const FEIDE = 'feide';

export const TEST_PRICE = 50;
export const SUBSCRIPTION_PRICE = 0;
export const CURRENCY_SYMBOL = strings.currencysymbol;

export const Z_SCORE_OFFSET = 4;
export const Z_SCORE_MAX = 8;

export const MINIMUM_AGE = 0;
export const MAXIMUM_AGE = 100;

export const ORDDIKTAT = 'ORDDIKTAT';
export const ORDKJEDETESTEN = 'ORDKJEDETESTEN';
export const TULLEORDTESTEN = 'TULLEORDTESTEN';
export const BYTTELYDTESTEN = 'BYTTELYDTESTEN';
export const SKRIVEHASTIGHET = 'SKRIVEHASTIGHET';
export const LESEPRØVEN = 'LESEPRØVEN';
export const ORDFORSTÅELSE = 'ORDFORSTÅELSE';
export const SPRAKFORSTÅELSE = 'SPRAKFORSTÅELSE';
export const WORKING_MEMORY = 'WORKING_MEMORY';
export const WORKING_MEMORY_NUMBERS = 'WORKING_MEMORY_NUMBERS';
export const WORKING_MEMORY_WORDS = 'WORKING_MEMORY_WORDS';
export const RAPID_NOMINATION = 'RAPID_NOMINATION';
export const MINUTE = 'MINUTE';
export const SPOONERISM = 'SPOONERISM';
export const LETTER_KNOWLEDGE = 'LETTER_KNOWLEDGE';
export const PHONEME_ISOLATION = 'PHONEME_ISOLATION';
export const PHONEME_DELETION = 'PHONEME_DELETION';
export const SENTENCE_MEMORY = 'SENTENCE_MEMORY';
export const NONWORD_REPETITION = 'NONWORD_REPETITION';
export const TEST_STEPS = {
	ORDDIKTAT,
	ORDKJEDETESTEN,
	TULLEORDTESTEN,
	SKRIVEHASTIGHET,
	LESEPRØVEN,
	ORDFORSTÅELSE,
};

export const TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[TULLEORDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
};

export const TEST_STEP_NORMING_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[TULLEORDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
	[SPRAKFORSTÅELSE]: 7,
};

export const TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 45,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatadultexplanation,
		reportExplainationNynorsk: strings._props.nn.orddiktatadultexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			default: {average: 38.38, standardDeviation: 4.54},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 56,
		label: 'Ordkjedetesten',
		reportHeading: strings.ordkjedetestenheading,
		reportHeadingNynorsk: strings._props.nn.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenexplanation,
		reportExplainationNynorsk: strings._props.nn.ordkjedetestenexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordkjedetestenvariabletext,
		norms: {
			default: {average: 15.38, standardDeviation: 5.1},
		},
	},
	3: {
		name: TULLEORDTESTEN,
		questionCount: 25,
		label: 'Tulleordtesten',
		reportHeading: strings.tulleordtestenheading,
		reportHeadingNynorsk: strings._props.nn.tulleordtestenheading,
		reportExplaination: strings.tulleordtestenexplanation,
		reportExplainationNynorsk: strings._props.nn.tulleordtestenexplanation,
		reportVariableText: strings.tulleordtestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.tulleordtestenvariabletext,
		norms: {
			default: {average: 13.87, standardDeviation: 5.07},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Skrivehastighet',
		reportHeading: strings.skrivehastighetheading,
		reportHeadingNynorsk: strings._props.nn.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportExplainationNynorsk: strings._props.nn.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.skrivehastighetvariabletext,
		norms: {
			default: {average: 20.28, standardDeviation: 3.76},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 14,
		label: 'Leseprøven',
		reportHeading: strings.leseprøvenheading,
		reportHeadingNynorsk: strings._props.nn.leseprøvenheading,
		reportExplaination: strings.leseprøvenexplanation,
		reportExplainationNynorsk: strings._props.nn.leseprøvenexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.leseprøvenvariabletext,
		reportLeseprovenExtraVariableText:
			strings._props.nn.reportLeseprovenExtraVariableText,
		reportLeseprovenExtraVariableText:
			strings.reportLeseprovenExtraVariableText,

		norms: {
			default: {average: 9.21, standardDeviation: 2.68},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 15,
		label: 'Ordforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelseexplanation,
		reportExplainationNynorsk: strings._props.nn.ordforståelseexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			default: {average: 10.55, standardDeviation: 2.56},
		},
	},
	7: {
		name: SPRAKFORSTÅELSE,
		questionCount: 21,
		label: 'Språkforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			default: {average: 10.55, standardDeviation: 2.56},
		},
	},
};
export const YOUTH_TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[TULLEORDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
};

export const YOUTH_TEST_NORMING_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[TULLEORDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
	[SPRAKFORSTÅELSE]: 7,
};

export const YOUTH_TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 30,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatyouthexplanation,
		reportExplainationNynorsk: strings._props.nn.orddiktatyouthexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			8: {average: 17.41, standardDeviation: 5.8},
			9: {average: 20.59, standardDeviation: 5.11},
			10: {average: 21.63, standardDeviation: 4.56},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 36,
		label: 'Ordkjedetesten',
		reportHeading: strings.ordkjedetestenheading,
		reportHeadingNynorsk: strings._props.nn.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenyouthexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordkjedetestenyouthexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordkjedetestenvariabletext,
		norms: {
			8: {average: 11.44, standardDeviation: 4.86},
			9: {average: 15.07, standardDeviation: 5.01},
			10: {average: 16.61, standardDeviation: 5.27},
		},
	},
	3: {
		name: TULLEORDTESTEN,
		questionCount: 25,
		label: 'Tulleordtesten',
		reportHeading: strings.tulleordtestenheading,
		reportHeadingNynorsk: strings._props.nn.tulleordtestenheading,
		reportExplaination: strings.tulleordtestenexplanation,
		reportExplainationNynorsk: strings._props.nn.tulleordtestenexplanation,
		reportVariableText: strings.tulleordtestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.tulleordtestenvariabletext,
		norms: {
			8: {average: 8.4, standardDeviation: 3.2},
			9: {average: 9.25, standardDeviation: 3.59},
			10: {average: 9.77, standardDeviation: 3.3},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Skrivehastighet',
		reportHeading: strings.skrivehastighetheading,
		reportHeadingNynorsk: strings._props.nn.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportExplainationNynorsk: strings._props.nn.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.skrivehastighetvariabletext,
		norms: {
			8: {average: 18.02, standardDeviation: 6.12},
			9: {average: 23.64, standardDeviation: 5.79},
			10: {average: 27.23, standardDeviation: 6.93},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 9,
		label: 'Leseprøven',
		reportHeading: strings.leseprøvenyouthheading,
		reportHeadingNynorsk: strings._props.nn.leseprøvenyouthheading,
		reportExplaination: strings.leseprøvenyouthexplanation,
		reportExplainationNynorsk: strings._props.nn.leseprøvenyouthexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.leseprøvenvariabletext,
		reportLeseprovenExtraVariableText:
			strings._props.nn.reportLeseprovenExtraVariableText,
		reportLeseprovenExtraVariableText:
			strings.reportLeseprovenExtraVariableText,
		norms: {
			8: {average: 3.78, standardDeviation: 2.34},
			9: {average: 4.42, standardDeviation: 1.99},
			10: {average: 5.04, standardDeviation: 1.86},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 20,
		label: 'Ordforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelseyouthexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelseyouthexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			8: {average: 13.25, standardDeviation: 2.73},
			9: {average: 14.04, standardDeviation: 2.89},
			10: {average: 14.87, standardDeviation: 2.41},
		},
	},
	7: {
		name: SPRAKFORSTÅELSE,
		questionCount: 21,
		label: 'Språkforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			8: {average: 13.25, standardDeviation: 2.73},
			9: {average: 14.04, standardDeviation: 2.89},
			10: {average: 14.87, standardDeviation: 2.41},
		},
	},
};

export const CHILD_SCRNG_TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[BYTTELYDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
};

export const CHILD_SCRNG_NORMING_TEST_STEP_IDS = {
	[ORDDIKTAT]: 1,
	[ORDKJEDETESTEN]: 2,
	[BYTTELYDTESTEN]: 3,
	[SKRIVEHASTIGHET]: 4,
	[LESEPRØVEN]: 5,
	[ORDFORSTÅELSE]: 6,
	[SPRAKFORSTÅELSE]: 7,
};

export const CHILD_SCRNG_TEST_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 25,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatChildscrexplanation,
		reportExplainationNynorsk:
			strings._props.nn.orddiktatChildscrexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			2: {average: 14.28, standardDeviation: 4.28},
			3: {average: 18.01, standardDeviation: 3.89},
			4: {average: 21.12, standardDeviation: 2.84},
			5: {average: 14.86, standardDeviation: 4.67},
			6: {average: 15.92, standardDeviation: 4.76},
			7: {average: 17.63, standardDeviation: 3.77},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 28,
		label: 'Ordkjedetesten',
		reportHeading: strings.ordkjedetestenheading,
		reportHeadingNynorsk: strings._props.nn.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenyouthexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordkjedetestenyouthexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordkjedetestenvariabletext,
		norms: {
			2: {average: 3.04, standardDeviation: 2.11},
			3: {average: 6.5, standardDeviation: 3.49},
			4: {average: 9.08, standardDeviation: 3.43},
			5: {average: 13.62, standardDeviation: 5.51},
			6: {average: 14.73, standardDeviation: 5.27},
			7: {average: 18.14, standardDeviation: 5.23},
		},
	},
	3: {
		name: BYTTELYDTESTEN,
		questionCount: 21,
		label: 'Byttelydtesten',
		reportHeading: strings.byttelydtestheading,
		reportHeadingNynorsk: strings._props.nn.byttelydtestheading,
		reportExplaination: strings.byttelydtestexplanation,
		reportExplainationNynorsk: strings._props.nn.byttelydtestexplanation,
		reportVariableText: strings.byttelydtestvariabletext,
		reportVariableTextNynorsk: strings._props.nn.byttelydtestvariabletext,
		norms: {
			2: {average: 11.94, standardDeviation: 4.14},
			3: {average: 14.26, standardDeviation: 4.3},
			4: {average: 16.32, standardDeviation: 3.34},
			5: {average: 18.98, standardDeviation: 1.66},
			6: {average: 19.08, standardDeviation: 1.52},
			7: {average: 19.81, standardDeviation: 1.16},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Skrivehastighet',
		reportHeading: strings.skrivehastighetheading,
		reportHeadingNynorsk: strings._props.nn.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportExplainationNynorsk: strings._props.nn.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.skrivehastighetvariabletext,
		norms: {
			2: {average: 3.04, standardDeviation: 2.11},
			3: {average: 5.02, standardDeviation: 3.3},
			4: {average: 9.55, standardDeviation: 4.06},
			5: {average: 13.62, standardDeviation: 4.67},
			6: {average: 16.71, standardDeviation: 5.82},
			7: {average: 21.04, standardDeviation: 6.1},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 8,
		label: 'Leseprøven',
		reportHeading: strings.leseprøvenchildheading,
		reportHeadingNynorsk: strings._props.nn.leseprøvenchildheading,
		reportExplaination: strings.leseprøvenchildexplanation,
		reportExplainationNynorsk: strings._props.nn.leseprøvenchildexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.leseprøvenvariabletext,
		reportLeseprovenExtraVariableText:
			strings._props.nn.reportLeseprovenExtraVariableText,
		reportLeseprovenExtraVariableText:
			strings.reportLeseprovenExtraVariableText,
		norms: {
			2: {average: 4.48, standardDeviation: 2.12},
			3: {average: 5.84, standardDeviation: 2.0},
			4: {average: 6.71, standardDeviation: 1.7},
			5: {average: 6.97, standardDeviation: 0.84},
			6: {average: 6.73, standardDeviation: 1.35},
			7: {average: 7.5, standardDeviation: 0.66},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 18,
		label: 'Ordforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			2: {average: 8.42, standardDeviation: 3.78},
			3: {average: 11.02, standardDeviation: 3.22},
			4: {average: 12.86, standardDeviation: 2.82},
			5: {average: 13.21, standardDeviation: 2.92},
			6: {average: 13.86, standardDeviation: 2.24},
			7: {average: 14.7, standardDeviation: 2.08},
		},
	},
	7: {
		name: SPRAKFORSTÅELSE,
		questionCount: 18,
		label: 'Språkforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			2: {average: 8.42, standardDeviation: 3.78},
			3: {average: 11.02, standardDeviation: 3.22},
			4: {average: 12.86, standardDeviation: 2.82},
			5: {average: 13.21, standardDeviation: 2.92},
			6: {average: 13.86, standardDeviation: 2.24},
			7: {average: 14.7, standardDeviation: 2.08},
		},
	},
};

export const CHILD_TEST_STEPS = {
	WORKING_MEMORY,
	WORKING_MEMORY_NUMBERS,
	WORKING_MEMORY_WORDS,
	RAPID_NOMINATION,
	MINUTE,
	SPOONERISM,
	LETTER_KNOWLEDGE,
	PHONEME_ISOLATION,
	PHONEME_DELETION,
	ORDDIKTAT,
	SENTENCE_MEMORY,
	NONWORD_REPETITION,
};

export const CHILD_TEST_STEPS_BY_ID = {
	0: {
		name: WORKING_MEMORY,
		questionCount: 24,
		showTotalCorrect: false,
		label: 'Arbeidsminne',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportExplainationNynorsk: strings._props.nn.arbeidsminneexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportVariableTextNynorsk: strings._props.nn.arbeidsminnevariabletext,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	1: {
		name: WORKING_MEMORY_NUMBERS,
		questionCount: 12,
		showTotalCorrect: false,
		label: 'Arbeidsminne (Tall)',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportHeading: strings.arbeidsminnenummberheading,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	2: {
		name: WORKING_MEMORY_WORDS,
		showTotalCorrect: false,
		questionCount: 12,
		label: 'Arbeidsminne (Ord)',
		reportHeading: strings.arbeidsminnenummberheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminnenummberheading,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	3: {
		name: RAPID_NOMINATION,
		showTotalCorrect: false,
		questionCount: 50,
		label: 'Hurtigbenevning',
		reportHeading: strings.hurtigbenevningheading,
		reportHeadingNynorsk: strings._props.nn.hurtigbenevningheading,
		reportExplaination: strings.hurtigbenevningexplanation,
		reportExplainationNynorsk: strings._props.nn.hurtigbenevningexplanation,
		reportBHexplaination: strings.hurtigbenevningBHexplanation,
		reportBHexplainationNynorsk:
			strings._props.nn.hurtigbenevningBHexplanation,
		reportVariableText: strings.hurtigbenevningvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.hurtigbenevningvariabletext,
		norms: {
			0: {average: 0.22, standardDeviation: 0.07},
			1: {average: 0.3, standardDeviation: 0.075},
			2: {average: 0.34, standardDeviation: 0.82},
			3: {average: 0.48, standardDeviation: 0.8},
			4: {average: 0.49, standardDeviation: 0.9},
			5: {average: 0.55, standardDeviation: 0.11},
			6: {average: 0.59, standardDeviation: 0.12},
			7: {average: 0.59, standardDeviation: 0.12},
			8: {average: 0.69, standardDeviation: 0.12},
			9: {average: 0.69, standardDeviation: 0.12},
			10: {average: 0.69, standardDeviation: 0.12},
			adult: {average: 0.79, standardDeviation: 0.11},
		},
	},
	4: {
		name: MINUTE,
		showTotalCorrect: false,
		questionCount: 119,
		label: 'Ettminuttstest',
		reportHeading: strings.ettminuttstestheading,
		reportHeadingNynorsk: strings._props.nn.ettminuttstestheading,
		reportExplaination: strings.ettminuttstestexplanation,
		reportExplainationNynorsk: strings._props.nn.ettminuttstestexplanation,
		reportVariableText: strings.ettminuttstestvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ettminuttstestvariabletext,
		norms: {
			1: {average: 17.07, standardDeviation: 11.58},
			2: {average: 37.99, standardDeviation: 17.81},
			3: {average: 52.68, standardDeviation: 18.96},
			4: {average: 58.36, standardDeviation: 14.86},
			5: {average: 69.12, standardDeviation: 15.2},
			6: {average: 74.18, standardDeviation: 14.36},
			7: {average: 77.17, standardDeviation: 13.69},
			8: {average: 85.75, standardDeviation: 10.33},
			9: {average: 85.75, standardDeviation: 10.33},
			10: {average: 85.75, standardDeviation: 10.33},
			adult: {average: 94.38, standardDeviation: 9.17},
		},
	},
	5: {
		name: SPOONERISM,
		showTotalCorrect: true,
		questionCount: 20,
		label: 'Spoonerism',
		reportHeading: strings.spoonerismheading,
		reportHeadingNynorsk: strings._props.nn.spoonerismheading,
		reportExplaination: strings.spoonerismexplanation,
		reportExplainationNynorsk: strings._props.nn.spoonerismexplanation,
		reportVariableText: strings.spoonerismvariabletext,
		reportVariableTextNynorsk: strings._props.nn.spoonerismvariabletext,
		norms: {
			8: {average: 0.12, standardDeviation: 0.06},
			9: {average: 0.12, standardDeviation: 0.06},
			10: {average: 0.12, standardDeviation: 0.06},
			adult: {average: 0.147, standardDeviation: 0.06},
		},
	},
	6: {
		name: LETTER_KNOWLEDGE,
		showTotalCorrect: true,
		questionCount: 30,
		label: 'Bokstavkunnskap',
		reportHeading: strings.bokstavkunnskapheading,
		reportHeadingNynorsk: strings._props.nn.bokstavkunnskapheading,
		reportExplaination: strings.bokstavkunnskapexplanation,
		reportExplainationNynorsk: strings._props.nn.bokstavkunnskapexplanation,
		reportVariableText: strings.bokstavkunnskapvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.bokstavkunnskapvariabletext,
		reportVariableTextBH: strings.bokstavkunnskapvariabletextBH,
		reportVariableTextBHNynorsk:
			strings._props.nn.bokstavkunnskapvariabletextBH,
		norms: {
			1: {average: 22.86, standardDeviation: 7.65},
			2: {average: 11.37, standardDeviation: 1.12},
		},
	},
	7: {
		name: PHONEME_ISOLATION,
		showTotalCorrect: true,
		questionCount: 16,
		label: 'Fonemisolasjon',
		reportHeading: strings.fonemisolasjonheading,
		reportHeadingNynorsk: strings._props.nn.fonemisolasjonheading,
		reportExplaination: strings.fonemisolasjonexplanation,
		reportExplainationNynorsk: strings._props.nn.fonemisolasjonexplanation,
		reportVariableText: strings.fonemisolasjonvariabletext,
		reportVariableTextNynorsk: strings._props.nn.fonemisolasjonvariabletext,
		norms: {
			0: {average: 8.16, standardDeviation: 4.01},
			1: {average: 12.52, standardDeviation: 2.52},
			2: {average: 6.34, standardDeviation: 1.03},
		},
	},
	8: {
		name: PHONEME_DELETION,
		showTotalCorrect: true,
		questionCount: 16,
		label: 'Fonemutelatelse',
		reportHeading: strings.fonemutelatelseheading,
		reportHeadingNynorsk: strings._props.nn.fonemutelatelseheading,
		reportExplaination: strings.fonemutelatelseexplanation,
		reportExplainationNynorsk: strings._props.nn.fonemutelatelseexplanation,
		reportVariableText: strings.fonemutelatelsevariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.fonemutelatelsevariabletext,
		norms: {
			2: {average: 10.53, standardDeviation: 4.28},
			3: {average: 12.22, standardDeviation: 3.46},
			4: {average: 12.86, standardDeviation: 2.98},
			5: {average: 14.02, standardDeviation: 2.26},
			6: {average: 14.45, standardDeviation: 2.16},
			7: {average: 14.96, standardDeviation: 1.54},
		},
	},
	9: {
		name: ORDDIKTAT,
		showTotalCorrect: true,
		questionCount: 13,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatchildexplanation,
		reportExplainationNynorsk: strings._props.nn.orddiktatchildexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			3: {average: 6.81, standardDeviation: 2.19},
			4: {average: 7.4, standardDeviation: 3.23},
			5: {average: 9.07, standardDeviation: 2.6},
			6: {average: 9.4, standardDeviation: 3.06},
			7: {average: 9.81, standardDeviation: 2.22},
		},
	},
	10: {
		name: SENTENCE_MEMORY,
		questionCount: 48,
		showTotalCorrect: false,
		label: 'Setningsminne',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportExplainationNynorsk: strings._props.nn.arbeidsminneexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportVariableTextNynorsk: strings._props.nn.arbeidsminnevariabletext,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	12: {
		name: MINUTE,
		showTotalCorrect: false,
		questionCount: 120,
		label: 'Ettminuttstest',
		reportHeading: strings.ettminuttstestheading,
		reportHeadingNynorsk: strings._props.nn.ettminuttstestheading,
		reportExplaination: strings.ettminuttstestexplanation,
		reportExplainationNynorsk: strings._props.nn.ettminuttstestexplanation,
		reportVariableText: strings.ettminuttstestvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ettminuttstestvariabletext,
		norms: {
			1: {average: 17.07, standardDeviation: 11.58},
			2: {average: 37.99, standardDeviation: 17.81},
			3: {average: 52.68, standardDeviation: 18.96},
			4: {average: 58.36, standardDeviation: 14.86},
			5: {average: 69.12, standardDeviation: 15.2},
			6: {average: 74.18, standardDeviation: 14.36},
			7: {average: 77.17, standardDeviation: 13.69},
			8: {average: 85.75, standardDeviation: 10.336},
			9: {average: 85.75, standardDeviation: 10.336},
			10: {average: 85.75, standardDeviation: 10.336},
		},
	},
	13: {
		name: NONWORD_REPETITION,
		questionCount: 32,
		showTotalCorrect: false,
		label: 'Nonordrepetition',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportExplainationNynorsk: strings._props.nn.arbeidsminneexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportVariableTextNynorsk: strings._props.nn.arbeidsminnevariabletext,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
};

// User stages
export const TRIAL_TEST_LIMIT = 2;

export const NEEDS_APPROVAL = 'NEEDS_APPROVAL';
export const AWAITING_CONFIRMATION = 'AWAITING_CONFIRMATION';
export const TRIAL = 'TRIAL';
export const EXPIRED_TRIAL = 'EXPIRED_TRIAL';
export const BASIC = 'BASIC';
export const FULL = 'FULL';

export const ADULT = 'ADULT';
export const CHILD = 'CHILD';
export const YOUTH = 'YOUTH';
export const INACTIVE = 'INACTIVE';
export const ACTIVE = 'ACTIVE';
export const NORMING = 'NORMING';
export const PRODUKSJON = 'PRODUKSJON';
export const PROD_NORMING = 'PROD_NORMING';
export const CHILD_YOUTH = 'CHILD_YOUTH';
export const CHILD_ADULT = 'CHILD_ADULD';
export const YOUTH_ADULT = 'YOUTH_ADULT';
export const CHILD_YOUTH_ADULT = 'CHILD_YOUTH_ADULT';

export const svensk = {
	id: 2,
	language: 'swedish',
	lang: 'Svensk',
	active: false,
	hideText: 'Svensk ▲',
	revealText: 'Svensk ▼',
	default: false,
	labelId: null,
};

export const norsk = {
	id: 1,
	language: 'norwegian',
	lang: 'Norsk',
	active: false,
	hideText: 'Norsk ▲',
	revealText: 'Norsk ▼',
	default: false,
	labelId: null,
};
export const english = {
	id: 3,
	language: 'english',
	lang: 'Engelsk',
	active: false,
	hideText: 'Engelsk ▲',
	revealText: 'Engelsk ▼',
	default: false,
	labelId: null,
};

export const dutch = {
	id: 4,
	language: 'dutch',
	lang: 'Dutch',
	active: false,
	hideText: 'Dutch ▲',
	revealText: 'Dutch ▼',
	default: false,
	labelId: null,
};

export const german = {
	id: 5,
	language: 'german',
	lang: 'Tysk',
	active: false,
	hideText: 'Tysk ▲',
	revealText: 'Tysk ▼',
	default: false,
	labelId: null,
};

export const language = [norsk, svensk, english, dutch, german];

export const ENGLISH = 'Engelsk';
export const SWEDISH = 'Svensk';
export const NORWEGIAN = 'Norsk';
export const DUTCH = 'Dutch';
export const GERMAN = 'Tysk';

export const USER_SUBSCRIPTIONS_INFO = {
	[ENGLISH]: {
		subscriptionUpdate: {
			language: 'english',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[SWEDISH]: {
		subscriptionUpdate: {
			language: 'swedish',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[NORWEGIAN]: {
		subscriptionUpdate: {
			language: 'norwegian',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[DUTCH]: {
		subscriptionUpdate: {
			language: 'dutch',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
	[GERMAN]: {
		subscriptionUpdate: {
			language: 'german',
			child: 0,
			youth: 0,
			adult: 0,
			child_followup: 0,
			youth_followup: 0,
			adult_followup: 0,
			norming_child: 0,
			norming_youth: 0,
			norming_adult: 0,
			basic: 0,
		},
	},
};

export const USER_STAGES_INFO = {
	[NEEDS_APPROVAL]: {
		id: NEEDS_APPROVAL,
		className: 'needs-approval',
		longText: 'Må godkjennes av administrator',
		text: 'Trenger godkjenning',
	},
	[AWAITING_CONFIRMATION]: {
		id: AWAITING_CONFIRMATION,
		className: 'awaiting',
		longText: 'Bruker er godkjent og e-post er sendt med invitasjon',
		text: 'Ikke fullført registrering',
	},
	[TRIAL]: {
		id: TRIAL,
		className: 'trial',
		longText: 'Har kun tilgang til totalt 8 tester',
		text: 'Prøveperiode',
	},
	[BASIC]: {
		id: BASIC,
		className: 'basic',
		longText: 'Har kun tilgang til å se testresultater',
		text: 'Basis abonnement',
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[ACTIVE]: {
		id: ACTIVE,
		className: 'active',
		longText: 'Har tilgang til å lage nye tester og se testresultater',
		text: 'Active abonnement',
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[NORMING]: {
		id: NORMING,
		className: 'active',
		longText:
			'Har tilgang til å lage normering tester og se testresultater',
		text: 'Normering',
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[PRODUKSJON]: {
		id: PRODUKSJON,
		className: 'active',
		longText: 'Har tilgang til å lage tester og se testresultater',
		text: 'Abonnement',
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[PROD_NORMING]: {
		id: PROD_NORMING,
		className: 'active',
		longText: 'Har full tilgang til å lage nye tester og se testresultater',
		text: 'Fullt abonnement',
		subscriptionUpdates: {
			active: true,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
	[INACTIVE]: {
		id: INACTIVE,
		className: 'inactive',
		longText:
			'Har ikke tilgang til å lage nye tester eller se testresultater',
		text: 'Inaktiv',
		subscriptionUpdates: {
			active: false,
			full: false,
			trial: false,
			child: false,
			youth: false,
			adult: false,
			norming: false,
		},
	},
};

export const allChildGrades = [
	{
		id: 2,

		value: 2,
		label: '2. Trinn',
	},
	{
		id: 3,

		value: 3,
		label: '3. Trinn',
	},
	{
		id: 4,

		value: 4,
		label: '4. Trinn',
	},
	{
		id: 5,

		value: 5,
		label: '5. Trinn',
	},
	{
		id: 6,

		value: 6,
		label: '6. Trinn',
	},
	{
		id: 7,

		value: 7,
		label: '7. Trinn',
	},
];

export const allYouthGrades = [
	{
		id: 1,

		value: 8,
		label: '8. Trinn',
	},
	{
		id: 2,

		value: 9,
		label: '9. Trinn',
	},
	{
		id: 3,

		value: 10,
		label: '10. Trinn',
	},
];

export const allAdultGrades = [
	{
		id: 1,

		value: 'College',
		label: 'Videregående skole',
	},
	{
		id: 2,

		value: 'University',
		label: 'Universitet/høgskole',
	},

	{
		id: 3,

		value: 'Voksenopplæring',
		label: 'Voksenopplæring',
	},
	{
		id: 4,

		value: 'Other',
		label: 'Annet',
	},
];

export const controlPanel = '/control-panel';
export const notifications = '/notifications';

export const CHILD_TEST_NORMING_STEPS_BY_ID = {
	0: {
		name: WORKING_MEMORY,
		questionCount: 24,
		questionCountChild: 24,
		questionCountYouthAdult: 24,
		showTotalCorrect: false,
		label: 'Arbeidsminne',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportExplainationNynorsk: strings._props.nn.arbeidsminneexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportVariableTextNynorsk: strings._props.nn.arbeidsminnevariabletext,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	1: {
		name: WORKING_MEMORY_NUMBERS,
		questionCount: 12,
		questionCountChild: 12,
		questionCountYouthAdult: 12,
		showTotalCorrect: false,
		label: 'Arbeidsminne (Tall)',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportHeading: strings.arbeidsminnenummberheading,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	2: {
		name: WORKING_MEMORY_WORDS,
		showTotalCorrect: false,
		questionCount: 12,
		questionCountChild: 12,
		questionCountYouthAdult: 12,
		label: 'Arbeidsminne (Ord)',
		reportHeading: strings.arbeidsminnenummberheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminnenummberheading,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	3: {
		name: RAPID_NOMINATION,
		showTotalCorrect: false,
		questionCount: 50,
		questionCountChild: 50,
		questionCountYouthAdult: 50,
		label: 'Hurtigbenevning',
		reportHeading: strings.hurtigbenevningheading,
		reportHeadingNynorsk: strings._props.nn.hurtigbenevningheading,
		reportExplaination: strings.hurtigbenevningexplanation,
		reportExplainationNynorsk: strings._props.nn.hurtigbenevningexplanation,
		reportBHexplaination: strings.hurtigbenevningBHexplanation,
		reportBHexplainationNynorsk:
			strings._props.nn.hurtigbenevningBHexplanation,
		reportVariableText: strings.hurtigbenevningvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.hurtigbenevningvariabletext,
		norms: {
			0: {average: 0.22, standardDeviation: 0.07},
			1: {average: 0.3, standardDeviation: 0.075},
			2: {average: 0.34, standardDeviation: 0.82},
			3: {average: 0.48, standardDeviation: 0.8},
			4: {average: 0.49, standardDeviation: 0.9},
			5: {average: 0.55, standardDeviation: 0.11},
			6: {average: 0.59, standardDeviation: 0.12},
			7: {average: 0.59, standardDeviation: 0.12},
			8: {average: 0.69, standardDeviation: 0.12},
			9: {average: 0.69, standardDeviation: 0.12},
			10: {average: 0.69, standardDeviation: 0.12},
			adult: {average: 0.79, standardDeviation: 0.11},
		},
	},
	4: {
		name: MINUTE,
		showTotalCorrect: false,
		questionCount: 119,
		questionCountChild: 119,
		questionCountYouthAdult: 119,
		label: 'Ettminuttstest',
		reportHeading: strings.ettminuttstestheading,
		reportHeadingNynorsk: strings._props.nn.ettminuttstestheading,
		reportExplaination: strings.ettminuttstestexplanation,
		reportExplainationNynorsk: strings._props.nn.ettminuttstestexplanation,
		reportVariableText: strings.ettminuttstestvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ettminuttstestvariabletext,
		norms: {
			1: {average: 17.07, standardDeviation: 11.58},
			2: {average: 37.99, standardDeviation: 17.81},
			3: {average: 52.68, standardDeviation: 18.96},
			4: {average: 58.36, standardDeviation: 14.86},
			5: {average: 69.12, standardDeviation: 15.2},
			6: {average: 74.18, standardDeviation: 14.36},
			7: {average: 77.17, standardDeviation: 13.69},
			8: {average: 85.75, standardDeviation: 10.33},
			9: {average: 85.75, standardDeviation: 10.33},
			10: {average: 85.75, standardDeviation: 10.33},
			adult: {average: 94.38, standardDeviation: 9.17},
		},
	},
	5: {
		name: SPOONERISM,
		showTotalCorrect: true,
		questionCount: 20,
		questionCountChild: 24,
		questionCountYouthAdult: 32,
		label: 'Spoonerism',
		reportHeading: strings.spoonerismheading,
		reportHeadingNynorsk: strings._props.nn.spoonerismheading,
		reportExplaination: strings.spoonerismexplanation,
		reportExplainationNynorsk: strings._props.nn.spoonerismexplanation,
		reportVariableText: strings.spoonerismvariabletext,
		reportVariableTextNynorsk: strings._props.nn.spoonerismvariabletext,
		norms: {
			8: {average: 0.12, standardDeviation: 0.06},
			9: {average: 0.12, standardDeviation: 0.06},
			10: {average: 0.12, standardDeviation: 0.06},
			adult: {average: 0.147, standardDeviation: 0.06},
		},
	},
	6: {
		name: LETTER_KNOWLEDGE,
		showTotalCorrect: true,
		questionCount: 30,
		questionCountChild: 30,
		questionCountYouthAdult: 30,
		label: 'Bokstavkunnskap',
		reportHeading: strings.bokstavkunnskapheading,
		reportHeadingNynorsk: strings._props.nn.bokstavkunnskapheading,
		reportExplaination: strings.bokstavkunnskapexplanation,
		reportExplainationNynorsk: strings._props.nn.bokstavkunnskapexplanation,
		reportVariableText: strings.bokstavkunnskapvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.bokstavkunnskapvariabletext,
		reportVariableTextBH: strings.bokstavkunnskapvariabletextBH,
		reportVariableTextBHNynorsk:
			strings._props.nn.bokstavkunnskapvariabletextBH,
		norms: {
			1: {average: 22.86, standardDeviation: 7.65},
			2: {average: 11.37, standardDeviation: 1.12},
		},
	},
	7: {
		name: PHONEME_ISOLATION,
		showTotalCorrect: true,
		questionCount: 16,
		questionCountChild: 16,
		questionCountYouthAdult: 16,
		label: 'Fonemisolasjon',
		reportHeading: strings.fonemisolasjonheading,
		reportHeadingNynorsk: strings._props.nn.fonemisolasjonheading,
		reportExplaination: strings.fonemisolasjonexplanation,
		reportExplainationNynorsk: strings._props.nn.fonemisolasjonexplanation,
		reportVariableText: strings.fonemisolasjonvariabletext,
		reportVariableTextNynorsk: strings._props.nn.fonemisolasjonvariabletext,
		norms: {
			0: {average: 8.16, standardDeviation: 4.01},
			1: {average: 12.52, standardDeviation: 2.52},
			2: {average: 6.34, standardDeviation: 1.03},
		},
	},
	8: {
		name: PHONEME_DELETION,
		showTotalCorrect: true,
		questionCount: 16,
		questionCountChild: 16,
		questionCountYouthAdult: 16,
		label: 'Fonemutelatelse',
		reportHeading: strings.fonemutelatelseheading,
		reportHeadingNynorsk: strings._props.nn.fonemutelatelseheading,
		reportExplaination: strings.fonemutelatelseexplanation,
		reportExplainationNynorsk: strings._props.nn.fonemutelatelseexplanation,
		reportVariableText: strings.fonemutelatelsevariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.fonemutelatelsevariabletext,
		norms: {
			2: {average: 10.53, standardDeviation: 4.28},
			3: {average: 12.22, standardDeviation: 3.46},
			4: {average: 12.86, standardDeviation: 2.98},
			5: {average: 14.02, standardDeviation: 2.26},
			6: {average: 14.45, standardDeviation: 2.16},
			7: {average: 14.96, standardDeviation: 1.54},
		},
	},
	9: {
		name: ORDDIKTAT,
		showTotalCorrect: true,
		questionCount: 13,
		questionCountChild: 13,
		questionCountYouthAdult: 13,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatchildexplanation,
		reportExplainationNynorsk: strings._props.nn.orddiktatchildexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			3: {average: 6.81, standardDeviation: 2.19},
			4: {average: 7.4, standardDeviation: 3.23},
			5: {average: 9.07, standardDeviation: 2.6},
			6: {average: 9.4, standardDeviation: 3.06},
			7: {average: 9.81, standardDeviation: 2.22},
		},
	},
	10: {
		name: SENTENCE_MEMORY,
		questionCount: 48,
		questionCountChild: 40,
		questionCountYouthAdult: 48,
		showTotalCorrect: false,
		label: 'Setningsminne',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportExplainationNynorsk: strings._props.nn.arbeidsminneexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportVariableTextNynorsk: strings._props.nn.arbeidsminnevariabletext,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
	12: {
		name: MINUTE,
		showTotalCorrect: false,
		questionCount: 120,
		questionCountChild: 120,
		questionCountYouthAdult: 120,
		label: 'Ettminuttstest',
		reportHeading: strings.ettminuttstestheading,
		reportHeadingNynorsk: strings._props.nn.ettminuttstestheading,
		reportExplaination: strings.ettminuttstestexplanation,
		reportExplainationNynorsk: strings._props.nn.ettminuttstestexplanation,
		reportVariableText: strings.ettminuttstestvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ettminuttstestvariabletext,
		norms: {
			1: {average: 17.07, standardDeviation: 11.58},
			2: {average: 37.99, standardDeviation: 17.81},
			3: {average: 52.68, standardDeviation: 18.96},
			4: {average: 58.36, standardDeviation: 14.86},
			5: {average: 69.12, standardDeviation: 15.2},
			6: {average: 74.18, standardDeviation: 14.36},
			7: {average: 77.17, standardDeviation: 13.69},
			8: {average: 85.75, standardDeviation: 10.336},
			9: {average: 85.75, standardDeviation: 10.336},
			10: {average: 85.75, standardDeviation: 10.336},
		},
	},
	13: {
		name: NONWORD_REPETITION,
		questionCount: 32,
		questionCountChild: 20,
		questionCountYouthAdult: 24,
		showTotalCorrect: false,
		label: 'Nonordrepetition',
		reportHeading: strings.arbeidsminneheading,
		reportHeadingNynorsk: strings._props.nn.arbeidsminneheading,
		reportExplaination: strings.arbeidsminneexplanation,
		reportExplainationNynorsk: strings._props.nn.arbeidsminneexplanation,
		reportVariableText: strings.arbeidsminnevariabletext,
		reportVariableTextNynorsk: strings._props.nn.arbeidsminnevariabletext,
		norms: {
			0: {average: 3.79, standardDeviation: 2.84},
			1: {average: 6.37, standardDeviation: 1.87},
			2: {average: 6.95, standardDeviation: 1.63},
			3: {average: 7.23, standardDeviation: 2.15},
			4: {average: 8.24, standardDeviation: 2.14},
			5: {average: 8.62, standardDeviation: 2.09},
			6: {average: 9.08, standardDeviation: 2.45},
			7: {average: 9.25, standardDeviation: 2.27},
			8: {average: 10.5, standardDeviation: 2.67},
			9: {average: 10.5, standardDeviation: 2.67},
			10: {average: 10.5, standardDeviation: 2.67},
			adult: {average: 10.4, standardDeviation: 2.57},
		},
	},
};

export const TEST_NORMING_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 35,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatadultexplanation,
		reportExplainationNynorsk: strings._props.nn.orddiktatadultexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			default: {average: 38.38, standardDeviation: 4.54},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 56,
		label: 'Ordkjedetesten',
		reportHeading: strings.ordkjedetestenheading,
		reportHeadingNynorsk: strings._props.nn.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenexplanation,
		reportExplainationNynorsk: strings._props.nn.ordkjedetestenexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordkjedetestenvariabletext,
		norms: {
			default: {average: 15.38, standardDeviation: 5.1},
		},
	},
	3: {
		name: TULLEORDTESTEN,
		questionCount: 25,
		label: 'Tulleordtesten',
		reportHeading: strings.tulleordtestenheading,
		reportHeadingNynorsk: strings._props.nn.tulleordtestenheading,
		reportExplaination: strings.tulleordtestenexplanation,
		reportExplainationNynorsk: strings._props.nn.tulleordtestenexplanation,
		reportVariableText: strings.tulleordtestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.tulleordtestenvariabletext,
		norms: {
			default: {average: 13.87, standardDeviation: 5.07},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Skrivehastighet',
		reportHeading: strings.skrivehastighetheading,
		reportHeadingNynorsk: strings._props.nn.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportExplainationNynorsk: strings._props.nn.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.skrivehastighetvariabletext,
		norms: {
			default: {average: 20.28, standardDeviation: 3.76},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 13,
		label: 'Leseprøven',
		reportHeading: strings.leseprøvenheading,
		reportHeadingNynorsk: strings._props.nn.leseprøvenheading,
		reportExplaination: strings.leseprøvenexplanation,
		reportExplainationNynorsk: strings._props.nn.leseprøvenexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.leseprøvenvariabletext,
		reportLeseprovenExtraVariableText:
			strings._props.nn.reportLeseprovenExtraVariableText,
		reportLeseprovenExtraVariableText:
			strings.reportLeseprovenExtraVariableText,

		norms: {
			default: {average: 9.21, standardDeviation: 2.68},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 25,
		label: 'Ordforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelseexplanation,
		reportExplainationNynorsk: strings._props.nn.ordforståelseexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			default: {average: 10.55, standardDeviation: 2.56},
		},
	},
	7: {
		name: SPRAKFORSTÅELSE,
		questionCount: 18,
		label: 'Språkforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			default: {average: 10.55, standardDeviation: 2.56},
		},
	},
};

export const YOUTH_TEST_NORMING_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 30,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatyouthexplanation,
		reportExplainationNynorsk: strings._props.nn.orddiktatyouthexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			8: {average: 17.41, standardDeviation: 5.8},
			9: {average: 20.59, standardDeviation: 5.11},
			10: {average: 21.63, standardDeviation: 4.56},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 36,
		label: 'Ordkjedetesten',
		reportHeading: strings.ordkjedetestenheading,
		reportHeadingNynorsk: strings._props.nn.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenyouthexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordkjedetestenyouthexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordkjedetestenvariabletext,
		norms: {
			8: {average: 11.44, standardDeviation: 4.86},
			9: {average: 15.07, standardDeviation: 5.01},
			10: {average: 16.61, standardDeviation: 5.27},
		},
	},
	3: {
		name: TULLEORDTESTEN,
		questionCount: 25,
		label: 'Tulleordtesten',
		reportHeading: strings.tulleordtestenheading,
		reportHeadingNynorsk: strings._props.nn.tulleordtestenheading,
		reportExplaination: strings.tulleordtestenexplanation,
		reportExplainationNynorsk: strings._props.nn.tulleordtestenexplanation,
		reportVariableText: strings.tulleordtestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.tulleordtestenvariabletext,
		norms: {
			8: {average: 8.4, standardDeviation: 3.2},
			9: {average: 9.25, standardDeviation: 3.59},
			10: {average: 9.77, standardDeviation: 3.3},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		label: 'Skrivehastighet',
		reportHeading: strings.skrivehastighetheading,
		reportHeadingNynorsk: strings._props.nn.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportExplainationNynorsk: strings._props.nn.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.skrivehastighetvariabletext,
		norms: {
			8: {average: 18.02, standardDeviation: 6.12},
			9: {average: 23.64, standardDeviation: 5.79},
			10: {average: 27.23, standardDeviation: 6.93},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 10,
		label: 'Leseprøven',
		reportHeading: strings.leseprøvenyouthheading,
		reportHeadingNynorsk: strings._props.nn.leseprøvenyouthheading,
		reportExplaination: strings.leseprøvenyouthexplanation,
		reportExplainationNynorsk: strings._props.nn.leseprøvenyouthexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.leseprøvenvariabletext,
		reportLeseprovenExtraVariableText:
			strings._props.nn.reportLeseprovenExtraVariableText,
		reportLeseprovenExtraVariableText:
			strings.reportLeseprovenExtraVariableText,
		norms: {
			8: {average: 3.78, standardDeviation: 2.34},
			9: {average: 4.42, standardDeviation: 1.99},
			10: {average: 5.04, standardDeviation: 1.86},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 20,
		label: 'Ordforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelseyouthexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelseyouthexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			8: {average: 13.25, standardDeviation: 2.73},
			9: {average: 14.04, standardDeviation: 2.89},
			10: {average: 14.87, standardDeviation: 2.41},
		},
	},
	7: {
		name: SPRAKFORSTÅELSE,
		questionCount: 18,
		label: 'Språkforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			8: {average: 13.25, standardDeviation: 2.73},
			9: {average: 14.04, standardDeviation: 2.89},
			10: {average: 14.87, standardDeviation: 2.41},
		},
	},
};

export const CHILD_SCRNG_TEST_NORMING_STEPS_BY_ID = {
	1: {
		name: ORDDIKTAT,
		questionCount: 25,
		questionChild234: 20,
		questionChild567: 25,
		label: 'Orddiktat',
		reportHeading: strings.orddiktatheading,
		reportHeadingNynorsk: strings._props.nn.orddiktatheading,
		reportExplaination: strings.orddiktatChildscrexplanation,
		reportExplainationNynorsk:
			strings._props.nn.orddiktatChildscrexplanation,
		reportVariableText: strings.orddiktatvariabletext,
		reportVariableTextNynorsk: strings._props.nn.orddiktatvariabletext,
		norms: {
			2: {average: 14.28, standardDeviation: 4.28},
			3: {average: 18.01, standardDeviation: 3.89},
			4: {average: 21.12, standardDeviation: 2.84},
			5: {average: 14.86, standardDeviation: 4.67},
			6: {average: 15.92, standardDeviation: 4.76},
			7: {average: 17.63, standardDeviation: 3.77},
		},
	},
	2: {
		name: ORDKJEDETESTEN,
		questionCount: 112,
		questionChild234: 112,
		questionChild567: 112,
		label: 'Ordkjedetesten',
		reportHeading: strings.ordkjedetestenheading,
		reportHeadingNynorsk: strings._props.nn.ordkjedetestenheading,
		reportExplaination: strings.ordkjedetestenyouthexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordkjedetestenyouthexplanation,
		reportVariableText: strings.ordkjedetestenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordkjedetestenvariabletext,
		norms: {
			2: {average: 3.04, standardDeviation: 2.11},
			3: {average: 6.5, standardDeviation: 3.49},
			4: {average: 9.08, standardDeviation: 3.43},
			5: {average: 13.62, standardDeviation: 5.51},
			6: {average: 14.73, standardDeviation: 5.27},
			7: {average: 18.14, standardDeviation: 5.23},
		},
	},
	3: {
		name: BYTTELYDTESTEN,
		questionCount: 21,
		questionChild234: 21,
		questionChild567: 21,
		label: 'Byttelydtesten',
		reportHeading: strings.byttelydtestheading,
		reportHeadingNynorsk: strings._props.nn.byttelydtestheading,
		reportExplaination: strings.byttelydtestexplanation,
		reportExplainationNynorsk: strings._props.nn.byttelydtestexplanation,
		reportVariableText: strings.byttelydtestvariabletext,
		reportVariableTextNynorsk: strings._props.nn.byttelydtestvariabletext,
		norms: {
			2: {average: 11.94, standardDeviation: 4.14},
			3: {average: 14.26, standardDeviation: 4.3},
			4: {average: 16.32, standardDeviation: 3.34},
			5: {average: 18.98, standardDeviation: 1.66},
			6: {average: 19.08, standardDeviation: 1.52},
			7: {average: 19.81, standardDeviation: 1.16},
		},
	},
	4: {
		name: SKRIVEHASTIGHET,
		questionCount: 0,
		questionChild234: 0,
		questionChild567: 0,
		label: 'Skrivehastighet',
		reportHeading: strings.skrivehastighetheading,
		reportHeadingNynorsk: strings._props.nn.skrivehastighetheading,
		reportExplaination: strings.skrivehastighetexplanation,
		reportExplainationNynorsk: strings._props.nn.skrivehastighetexplanation,
		reportVariableText: strings.skrivehastighetvariabletext,
		reportVariableTextNynorsk:
			strings._props.nn.skrivehastighetvariabletext,
		norms: {
			2: {average: 3.04, standardDeviation: 2.11},
			3: {average: 5.02, standardDeviation: 3.3},
			4: {average: 9.55, standardDeviation: 4.06},
			5: {average: 13.62, standardDeviation: 4.67},
			6: {average: 16.71, standardDeviation: 5.82},
			7: {average: 21.04, standardDeviation: 6.1},
		},
	},
	5: {
		name: LESEPRØVEN,
		questionCount: 8,
		questionChild234: 8,
		questionChild567: 8,
		label: 'Leseprøven',
		reportHeading: strings.leseprøvenchildheading,
		reportHeadingNynorsk: strings._props.nn.leseprøvenchildheading,
		reportExplaination: strings.leseprøvenchildexplanation,
		reportExplainationNynorsk: strings._props.nn.leseprøvenchildexplanation,
		reportVariableText: strings.leseprøvenvariabletext,
		reportVariableTextNynorsk: strings._props.nn.leseprøvenvariabletext,
		reportLeseprovenExtraVariableText:
			strings._props.nn.reportLeseprovenExtraVariableText,
		reportLeseprovenExtraVariableText:
			strings.reportLeseprovenExtraVariableText,
		norms: {
			2: {average: 4.48, standardDeviation: 2.12},
			3: {average: 5.84, standardDeviation: 2.0},
			4: {average: 6.71, standardDeviation: 1.7},
			5: {average: 6.97, standardDeviation: 0.84},
			6: {average: 6.73, standardDeviation: 1.35},
			7: {average: 7.5, standardDeviation: 0.66},
		},
	},
	6: {
		name: ORDFORSTÅELSE,
		questionCount: 18,
		questionChild234: 18,
		questionChild567: 18,
		label: 'Ordforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			2: {average: 8.42, standardDeviation: 3.78},
			3: {average: 11.02, standardDeviation: 3.22},
			4: {average: 12.86, standardDeviation: 2.82},
			5: {average: 13.21, standardDeviation: 2.92},
			6: {average: 13.86, standardDeviation: 2.24},
			7: {average: 14.7, standardDeviation: 2.08},
		},
	},
	7: {
		name: SPRAKFORSTÅELSE,
		questionCount: 18,
		questionChild234: 18,
		questionChild567: 18,
		label: 'Språkforståelse',
		reportHeading: strings.ordforståelseheading,
		reportHeadingNynorsk: strings._props.nn.ordforståelseheading,
		reportExplaination: strings.ordforståelsechildexplanation,
		reportExplainationNynorsk:
			strings._props.nn.ordforståelsechildexplanation,
		reportVariableText: strings.ordforståelsevariabletext,
		reportVariableTextNynorsk: strings._props.nn.ordforståelsevariabletext,
		norms: {
			2: {average: 8.42, standardDeviation: 3.78},
			3: {average: 11.02, standardDeviation: 3.22},
			4: {average: 12.86, standardDeviation: 2.82},
			5: {average: 13.21, standardDeviation: 2.92},
			6: {average: 13.86, standardDeviation: 2.24},
			7: {average: 14.7, standardDeviation: 2.08},
		},
	},
};
